import {
  ApiNoteInProgress,
  usePostByTenantNoteAndNoteIdInstructionActivateMutation
} from 'api/rtk-api'
import { ConfirmUsernameField } from 'components/core-v2'
import Icon from 'components/core-v2/atoms/Icon'
import IconButton from 'components/core-v2/molecules/iconButton'
import { intersection } from 'lodash'
import { FormProvider, useForm } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import { useUser } from 'utilities/hooks/useUser'

import { TENANT } from '../../../const'
import { useOnSuccess } from '../utilities/useOnSuccess'
import classes from './activation-tab.module.scss'
import { WaitingOnRoleAlert } from './waiting-on-role-alert'

const AUTHORISED_ROLES = ['Administrator', 'Trading']
interface Props {
  inProgressNote: ApiNoteInProgress
}
export const ActivateTab = ({ inProgressNote }: Props) => {
  const { data: user } = useUser()
  const { noteId } = useParams()
  const form = useForm()

  const onSuccess = useOnSuccess()

  const [submitApproval, { isLoading }] = usePostByTenantNoteAndNoteIdInstructionActivateMutation()

  if (!user) return null

  const isCurrentStage = inProgressNote.noteStatus === 'PendingActivation'
  const canUserCompleteStep = intersection(user.roles, AUTHORISED_ROLES).length > 0
  const isInteractive = isCurrentStage && canUserCompleteStep

  const onSubmit = async () => {
    const response = await submitApproval({
      tenant: TENANT,
      noteId
    })
    // Success
    if ('data' in response) {
      onSuccess()
    }
  }

  return (
    <FormProvider {...form}>
      {!canUserCompleteStep && isCurrentStage && <WaitingOnRoleAlert />}
      <form onSubmit={form.handleSubmit(onSubmit)}>
        {isInteractive && (
          <>
            <ConfirmUsernameField
              id="usernameConfirmation"
              label="To approve the amends, enter your username below and click on the button"
            />
            <div className={classes.buttonWrapper}>
              <IconButton
                icon={<Icon name="check" size="small" />}
                iconPosition="left"
                isLoading={isLoading}
                operationType="progress"
                text="Approve"
                type="submit"
              />
            </div>
          </>
        )}
      </form>
    </FormProvider>
  )
}
